import React, { useRef, useState, useEffect } from "react";
import { KEYS } from "utils/constants";
import { Button, ButtonType } from "components/common/Button.component";
import { TextInput } from "components/common/TextInput.component";

export function AddNew(props) {
    const [showNameInput, setShowNameInput] = useState(false);
    const [workflowName, setWorkflowName] = useState(props.defaultValue || "");
    const workflowNameRef = useRef(null);

    useEffect(() => {
        if (showNameInput && workflowNameRef.current) {
            workflowNameRef.current.focus();
        }
        // Notify parent component about input visibility
        if (props.onInputVisibilityChange) {
            props.onInputVisibilityChange(showNameInput);
        }
    }, [showNameInput]);

    const onBlur = function() {
        props.onBlur(workflowName);
        setShowNameInput(false);
    };

    const handleKeyDown = function(event) {
        switch (event.keyCode) {
            case KEYS.ENTER:
            case KEYS.TAB: {
                onBlur();
                return;
            }
            default:
                return event;
        }
    };

    const handleFocus = function(e) {
        e.target.select();
    };

    return (
        <div className="mx-0">
            {showNameInput &&
                <div className={`new d-flex align-items-center justify-content-between px-3 ${props.isFirst ? "radius-4":'radius-bottom-4'}`}>
                    <TextInput
                        ref={workflowNameRef}
                        className="ga-input__title ml-64"
                        value={workflowName}
                        onChange={(e) => setWorkflowName(e.target.value)}
                        onBlur={onBlur}
                        onFocus={handleFocus}
                        onKeyDown={handleKeyDown}
                    />
                    <Button type={ButtonType.SECONDARY}
                            onClick={onBlur}
                            text={props.addText}
                    />
                </div>
            }
            <div className="d-flex justify-content-end col-md-12 px-0 mt-4">
                <Button type={ButtonType.SECONDARY}
                        disabled={showNameInput}
                        onClick={e => {
                            setShowNameInput(true);
                        }}
                        text= {props.addNewText}
                />
            </div>
        </div>
    );
}